<div class="cash-out-container d-flex flex-column align-items-center p-4">
    <div class="cash-out-container-title d-flex align-items-center justify-content-start w-100">
        <div class="back-btn d-md-flex flex-row align-items-center" (click)="dialogRef.close()">
            <div class="back-btn-icon-container d-md-flex justify-content-center align-items-center">
                <mat-icon class="back-btn-icon-container-icon">arrow_back</mat-icon>
            </div>
            <span>Back</span>
        </div>
        <div class="flex-grow-1 text-center text-muted">Customer cash-out</div>
    </div>

    <div class="mt-5">
        <div class="mb-5 text-center cash-out-title">Scan the QR code to cash-out</div>

        <div class="d-flex justify-content-center">
            <app-spinner [isLoading]="loading" minHeight="5rem" />
            <img *ngIf="!loading" [src]="qrUrl" alt="" />
        </div>

        <div class="instruction d-flex flex-column align-items-center mt-5">
            <div class="instruction-item d-flex">
                <div>1.</div>
                <div>Open the camera from the mobile app and scan the QR code.</div>
            </div>
            <div class="instruction-item d-flex">
                <div>2.</div>
                <div>Enter the amount you want to cash-out and confirm your request</div>
            </div>
            <div class="instruction-item d-flex">
                <div>3.</div>
                <div>You’ll receive a notification once your request is approved</div>
            </div>
        </div>
    </div>

    <div class="cash-out-container-footer mb-2">
        <button (click)="onDownload()" mat-raised-button class="btn-primary rounded-pill mx-2" [class.btn-primary-disabled]="loading" [disabled]="loading">
            <mat-icon svgIcon="download"></mat-icon>
            Download QR Code
        </button>
    </div>
</div>
